import { render, staticRenderFns } from "./PhoneInputView.vue?vue&type=template&id=5e6e8d6e"
import script from "./PhoneInputView.vue?vue&type=script&lang=js"
export * from "./PhoneInputView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports